import React, { useState } from "react";
import { AncestorFilename, BaseConfiguration, InputFilenameAId, InputFilenameBId } from "./ConfigFormData";
import { InputIdentifier } from "./FileInput";
import { FileUploaderPresentationalComponent } from "./FileUploaderPresentationalComponent";


export interface FileUploaderProps{
    onFormDrop: (event: React.DragEvent<HTMLInputElement>, InputFileName: string) => void;
    formValues: BaseConfiguration ;
    inputIdentifier: any;
}

export const FileUploader : React.FunctionComponent<FileUploaderProps> = props => {

    const { onFormDrop, formValues, inputIdentifier } = props;
    var fileUploaderInput: HTMLElement | null = null;

    const [file, setFile] = useState<File | null>(null);
    const [dragEventCounter, setDragEventCounter] = useState(0);
  
    function dragenterListener(event: React.DragEvent<HTMLDivElement>) {
      overrideEventDefaults(event);
      setDragEventCounter(dragEventCounter + 1);
    };
  
    function dragleaveListener(event: React.DragEvent<HTMLDivElement>) {
      overrideEventDefaults(event);
      setDragEventCounter(dragEventCounter - 1);
    };
  
    function dropListener(event: React.DragEvent<HTMLInputElement>) {
      overrideEventDefaults(event);
      setDragEventCounter(0);
  
      if (event.dataTransfer.files && event.dataTransfer.files[0]) {
        setFile(event.dataTransfer.files[0]);
        if(inputIdentifier === InputIdentifier.A){
            formValues.InputFilenameA = event.dataTransfer.files[0].name;
            formValues.InputFileA = event.dataTransfer.files[0]; 
            onFormDrop(event, InputFilenameAId);
        }
        else if (inputIdentifier === InputIdentifier.B) {
            formValues.InputFilenameB = event.dataTransfer.files[0].name;
            formValues.InputFileB = event.dataTransfer.files[0];
            onFormDrop(event, InputFilenameBId);
        } else if (inputIdentifier === InputIdentifier.Ancestor) {
          formValues.AncestorFilename = event.dataTransfer.files[0].name;
          formValues.AncestorFile = event.dataTransfer.files[0];
          onFormDrop(event, AncestorFilename);
        }
      }
    };
  
    function overrideEventDefaults(event: Event | React.DragEvent<HTMLDivElement>) {
      event.preventDefault();
      event.stopPropagation();
    };
  
    function onSelectFileClick() {
      fileUploaderInput && fileUploaderInput.click();
    };

      return (
        <FileUploaderPresentationalComponent
          dragging={dragEventCounter > 0}
          file={file}
          onSelectFileClick={onSelectFileClick}
          onDrag={overrideEventDefaults}
          onDragStart={overrideEventDefaults}
          onDragEnd={overrideEventDefaults}
          onDragOver={overrideEventDefaults}
          onDragEnter={dragenterListener}
          onDragLeave={dragleaveListener}
          onDrop={dropListener}
        >{props.children}
        </FileUploaderPresentationalComponent>
      );
  }

  export default FileUploader;